import { useEffect } from 'react';

// Injects a <script type="application/ld+json"> into <head> for the current
// route. react-snap snapshots the DOM after effects run, so the schema ends up
// in the prerendered static HTML where search engines and LLM crawlers read it.
//
// Each block is keyed by `id` so re-renders upsert (never duplicate) and the
// script is removed on unmount, keeping per-route schema from leaking across
// prerendered pages.
//
// Usage:
//   <JsonLd id="service-mvp" data={{ '@context': 'https://schema.org', ... }} />
export default function JsonLd({ id, data }) {
  useEffect(() => {
    if (!data) return undefined;
    const scriptId = `ld-${id}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const existing = document.getElementById(scriptId);
      if (existing) existing.remove();
    };
  }, [id, data]);

  return null;
}
